//Module Keys
let locales = {};

//Merge Views
import login from 'Core/views/login/lan/es';
locales = { ...locales, ...login };

import confirmUser from 'Core/views/confirmUser/lan/es';
locales = { ...locales, ...confirmUser };

import forgotPassword from 'Core/views/forgotPassword/lan/es';
locales = { ...locales, ...forgotPassword };

import userAlerts from 'Core/views/userAlerts/lan/es'
locales = { ...locales, ...userAlerts };

import videoAlert from 'Core/views/videoAlert/lan/es';
locales = { ...locales,  ...videoAlert };

import header from 'Core/containers/Header/lan/es';
locales = { ...locales,  ...header };

import forceChangePassword from 'Core/views/forceChangePassword/lan/es';
locales = { ...locales, ...forceChangePassword };

import alertLog from 'Core/views/alertLog/lan/es';
locales = { ...locales,  ...alertLog };

import downloadReport from 'Core/views/downloadReport/lan/es';
locales = { ...locales,  ...downloadReport };

import useImportNotifications from 'Core/hooks/useImportNotifications/lan/es';
locales = { ...locales,  ...useImportNotifications };

import importResultsModal from 'Core/views/importResultsModal/lan/es';
locales = { ...locales,  ...importResultsModal };

export default locales;
